
import type { SVGProps } from 'react';
const SvgNotifications = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#notifications_svg__a)">
      <path
        fill="#263E6A"
        d="M4.5 18.73v-1h2v-7.5q0-1.997 1.27-3.514Q9.037 5.2 11 4.816v-.7a.97.97 0 0 1 1-1 .97.97 0 0 1 1 1v.7q1.962.385 3.23 1.9 1.27 1.517 1.27 3.515v7.5h2v1zm7.5 2.885q-.652 0-1.134-.462A1.53 1.53 0 0 1 10.385 20h3.23q0 .69-.462 1.153a1.57 1.57 0 0 1-1.153.462m-4.5-3.884h9v-7.5q0-1.881-1.31-3.19Q13.88 5.73 12 5.73T8.81 7.04 7.5 10.23z"
      />
    </g>
    <defs>
      <clipPath id="notifications_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNotifications;
